import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLoading } from '../../../context/LoadingContext';
import ProfileVisibility from "./ProfileVisibility";
import CompanyInformation from "./CompanyInformation";
import SecurityInformation from "./Security";
import EmailInformation from "./Email";
import BuyerFaqComp from "./Faq";
const BuyerProfileModule = () => {
    const [activeTab, setActiveTab] = useState("Profile & Visibility");
    const { setLoading } = useLoading();
    const navigate = useNavigate();
    const tabs = ["Profile & Visibility", "Company Information", "Email", "Security","FAQ"];
    const renderTabContent = () => {
        switch (activeTab) {
            case "Profile & Visibility":
                return <ProfileVisibility />;
            case "Company Information":
                return <CompanyInformation />;
            case "Security":
                return <SecurityInformation />;
            case "Email":
                return <EmailInformation />;
            case "FAQ":
                return <BuyerFaqComp />;
            default:
                <ProfileVisibility />

        }
    };
    return (
        <div className="buyer-layout">
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="mb-3 main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${activeTab === tab
                                        ? "active"
                                        : "notactive"
                                        }`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default BuyerProfileModule;